// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const defaultMakeData = () => Object.create(null);
// Useful for processing arguments objects as well as arrays.
const _Array$prototype = Array.prototype,
  forEach = _Array$prototype.forEach,
  slice = _Array$prototype.slice;
const hasOwnProperty = Object.prototype.hasOwnProperty;
export class Trie {
  constructor() {
    let weakness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let makeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMakeData;
    this.weakness = weakness;
    this.makeData = makeData;
  }
  lookup() {
    for (var _len = arguments.length, array = new Array(_len), _key = 0; _key < _len; _key++) {
      array[_key] = arguments[_key];
    }
    return this.lookupArray(array);
  }
  lookupArray(array) {
    let node = this;
    forEach.call(array, key => node = node.getChildTrie(key));
    return hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData(slice.call(array));
  }
  peek() {
    for (var _len2 = arguments.length, array = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      array[_key2] = arguments[_key2];
    }
    return this.peekArray(array);
  }
  peekArray(array) {
    let node = this;
    for (let i = 0, len = array.length; node && i < len; ++i) {
      const map = this.weakness && isObjRef(array[i]) ? node.weak : node.strong;
      node = map && map.get(array[i]);
    }
    return node && node.data;
  }
  getChildTrie(key) {
    const map = this.weakness && isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
    let child = map.get(key);
    if (!child) map.set(key, child = new Trie(this.weakness, this.makeData));
    return child;
  }
}
function isObjRef(value) {
  switch (typeof value) {
    case "object":
      if (value === null) break;
    // Fall through to return true...
    case "function":
      return true;
  }
  return false;
}